import React, { ReactNode } from 'react';
import Classes from './ListingAttribute.module.scss';

interface ListingAttributeProps {
  children: ReactNode;
  type?: string;
}

const ListingAttribute: React.FC<ListingAttributeProps> = ({ children, type }) => (
  <span
    className={`${Classes['hz-Attribute']} ${type ? Classes[`hz-Attribute--${type}`] : ''}`}
    suppressHydrationWarning
  >
    {children}
  </span>
);

export default ListingAttribute;
